module.exports = __webpack_public_path__ + "static/media/yoga_club.4be31e90.svg";